import { ChevronRightIcon } from "@heroicons/react/24/solid";
import UploadStep from "./UploadStep";
// import IconButton from "../../../../components/IconButton";
import constants from "../../../../commonUtils/constants";

const StepsNav = ({ stepVal }) => {
  
  const renderStep = () => {
    return (
      <>
        <div className="flex items-center gap-2 hidden md:flex">
          <UploadStep
            variant={stepVal === 1 ? "current" : "completed"}
            num="1"
            label={constants.upload.titles[1]}
          />
          
          <ChevronRightIcon className="w-5 h-5" />

          <UploadStep
            variant={stepVal === 2 ? "current" : stepVal > 2 ? "completed" : "upcoming"}
            num="2"
            label={constants.upload.titles[2]}
          />

          <ChevronRightIcon className="w-5 h-5" />

          <UploadStep
            variant={stepVal === 3 ? "current" : "upcoming"}
            num="3"
            label={constants.upload.titles[3]}
          />
        </div>
        <div className="flex items-center gap-2 block md:hidden pl-1">
          {/* <IconButton variant="ghost" size="icon-sm" Icon={ChevronLeftIcon} rounded="full" /> */}
          <UploadStep
              variant="current"
              num={stepVal}
              label={constants.upload.titles[stepVal]}
            />
        </div>
      </>
    );
  };

  return (
    <div className="w-full sm:w-full md:w-[400px] lg:w-[500px] my-2">
      {renderStep()}
    </div>
  );
};

export default StepsNav;

